import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import menuStore from '@/stores/menu-store.js'
import sessionStore from '@/stores/session-store.js'
import axios from 'axios'
import toastStore from '@/stores/toast-store.js'
import { ToggleButton } from 'vue-js-toggle-button'
import PromptWithButton from '@/vcs/_shared/modals/prompt-with-button/cmp.vue'

export default {
  name: 'ProfileBase',
  mixins: [CurrentUserResolver],
  data: function () {
    return {
      lang: '',
      hasCollectomatesWithByUserDeliveryScenario: false,
      skipLocationCheck: false,
    }
  },
  mounted() {
    this.fetchCollectomatesAndCheckForScenarios()
    this.lang = window.localStorage.getItem('lang_locale')
    this.skipLocationCheck = JSON.parse(window.localStorage.getItem('skipLocalizationCheck'))
  },
  watch: {
    currentUser: {
      handler: function (newVal) {
        if (newVal && !newVal.name && this.$isMbank) this.forceNameCompletion()
        if (newVal && newVal.name && this.$isMbank) this.showProfileSetupEndInfo()
      },
    },
  },
  computed: {
    isPhoneVerified() {
      return this.currentUser.phoneIsVerified
    },
    isNameAvailable() {
      return this.currentUser ? !!this.currentUser.name : true
    },
    stepsLeftCount() {
      let steps = 0
      !this.isNameAvailable ? steps++ : null
      !this.isPhoneVerified ? steps++ : null
      return steps
    },
  },
  methods: {
    forceNameCompletion() {
      this.$router.push('/profile/name')
    },

    showProfileSetupEndInfo() {
      const notice = window.localStorage.getItem('profile_complete_notice')
      if (!notice) {
        this.$store.commit('modal/open', {
          cmp: PromptWithButton,
          animation: 'slide-down-menu',
        })
        window.localStorage.setItem('profile_complete_notice', 'true')
      }
    },

    changeLocale(lang) {
      this.$i18n.locale = lang
      this.lang = lang
      window.localStorage.setItem('lang_locale', lang)
    },

    fetchCollectomatesAndCheckForScenarios() {
      axios({
        method: 'get',
        url: 'collection_points',
      })
        .then(response => {
          this.hasCollectomatesWithByUserDeliveryScenario =
            response.data.filter(cp => {
              return cp.deliveryScenarios[0] === 'by_user'
            }).length > 0
        })
        .catch(error => {
          const errorMessage = error.response.data.errors
            ? Object.values(error.response.data.errors).join(', ')
            : this.$t('messages.error')
          toastStore.commit('error', { message: errorMessage })
        })
    },

    // menu and callbacks
    openMenu() {
      menuStore.commit('open', [
        {
          text: this.$t('menu.dataLookup'),
          callback: this.sendUserData,
          color: '#009bde',
        },
        {
          text: this.$t('menu.signOut'),
          callback: this.logOut,
          color: '#009bde',
        },
        {
          text: this.$t('menu.deleteAccount'),
          callback: this.deleteAccount,
          color: '#e01a66',
        },
      ])
    },
    signOut() {
      return axios({
        method: 'delete',
        url: 'auth/sign_out',
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('collectomate_token')}`,
        },
      })
        .then(() => {
          this.processLogout()
        })
        .catch(error => {
          console.error('error signOut', error)
          toastStore.commit('error', {
            message: 'Sign out failed',
          })
        })
    },
    processLogout() {
      sessionStore.commit('setData', null)
      toastStore.commit('success', {
        message: this.$t('session.successSignOutToast'),
      })
    },
    sendUserData() {
      axios({
        method: 'get',
        url: `users/${this.currentUser.id}/get_data`,
      })
        .then(() => {
          toastStore.commit('success', {
            message: this.$t('messages.userDataSentToast'),
          })
        })
        .catch(error => {
          console.error('error sendUserData', error)
        })
      menuStore.commit('close')
    },
    deleteAccount() {
      menuStore.commit('close')
      if (confirm(this.$t('menu.deleteAccountConfirmation'))) {
        axios({
          method: 'delete',
          url: `users/${this.currentUser.id}`,
        })
          .then(response => {
            this.processLogout()
            console.log('response deleteAccount', response)
          })
          .catch(error => {
            console.error('error deleteAccount', error)
          })
      }
    },
    skipLocationCheckChanged(event) {
      this.skipLocationCheck = event.value
      window.localStorage.setItem('skipLocalizationCheck', event.value ? event.value : 'false')
    },
    async logOut() {
      if (this.$isZabka) {
        window.localStorage.setItem('add_logout', 'true')
        if (this.$msal) this.$msal.logoutRedirect()
      } else {
        this.standardLogOut()
      }
    },
    standardLogOut() {
      this.signOut().then(() => {
        if (this.isAuthenticatedWithOkta()) {
          this.$auth.signOut().then(() => {
            this.redirectLogOut()
          })
        } else {
          this.redirectLogOut()
        }
      })
    },
    isAuthenticatedWithOkta() {
      return this.authState && this.authState?.isAuthenticated
    },
    redirectLogOut() {
      menuStore.commit('close')
      this.$router.push('/')
    },
  },
  components: {
    ToggleButton,
  },
}
